import React, { useEffect, useState } from 'react';

import ProductSlider from './ProductSlider.jsx';
import { get } from '../../../common/httpService';
import './RelatedProducts.scss';

function RelatedProducts(props) {
    const [relations, setRelations] = useState([]);

    async function getRelatedProducts() {
        try {
            get({
                url: `Product/GetProductRelationsJson?slug=${props.slug}`,
            }).then((data) => {
                setRelations(data);
            });
        } catch (e) {
            console.error(e);
        }
    }

    useEffect(() => {
        if (props.alreadyHaveRelations) {
            setRelations(props.relations);
        } else {
            getRelatedProducts();
        }
    }, []);

    if (relations && relations.length > 0)
        return <ProductSlider products={relations} />;

    return <></>;
}

export default RelatedProducts;
